import {CrudModel} from '@ngx-ivengi/crud';
import {Assignment} from '../assignment/assignment.model';
import {Building} from '../building/building.model';
import {Channel} from '../channel/channel.model';
import {Floor} from '../floor/floor.model';
import {Room} from '../room/room.model';
import {Throughput} from '../throughput/throughput.model';

export class Datagrid extends CrudModel {
  public assignment: Assignment;
  public building: Building;
  public floor: Floor;
  public roomFrom: Room;
  public roomTo: Room;
  public channel: Channel;
  public throughputs: Throughput[] = [];

  fromResponse(response: any): void {
    (this.channel     = new Channel()).fromResponse(response);

    if(response.assignment) {
      (this.assignment  = new Assignment()).fromResponse(response.assignment);
    }

    if(response.building) {
      (this.building    = new Building()).fromResponse(response.building);
    }

    if(response.floor) {
      (this.floor       = new Floor()).fromResponse(response.floor);
    }

    if(response.roomFrom) {
      (this.roomFrom    = new Room()).fromResponse((response.roomFrom));
    }

    if(response.roomTo) {
      (this.roomTo      = new Room()).fromResponse((response.roomTo));
    }

    if(typeof response.throughputs === 'object' && response.throughputs instanceof Array) {
      for(const throughput of response.throughputs) {
        const throughputModel = new Throughput();
        throughputModel.fromResponse(throughput);
        this.throughputs.push(throughputModel);
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid.model.ts